<template>
	<div class="readpage_body" v-if="fileInfo" @click="showBottomBox = false">
		<div class="readpage_top">
			<div class="left">
				<img src="@comm/images/document-conversion/zxyl/ofd_icon.png" v-if="fileInfo.fileType == 'ofd'" alt=''/>
				<img
					src="@comm/images/document-conversion/zxyl/pdf_icon.png"
					v-else-if="fileInfo.fileType == 'pdf'" alt=''
				/>
				<img
					src="@comm/images/document-conversion/zxyl/word_icon.png"
					v-else-if="['doc', 'docx'].includes(fileInfo.fileType)" alt=''
				/>
				<img
					src="@comm/images/document-conversion/zxyl/excel_icon.png"
					v-else-if="['xls', 'xlsx'].includes(fileInfo.fileType)" alt=''
				/>
				<img
					src="@comm/images/document-conversion/zxyl/tiff_icon.png"
					v-else-if="['tiff', 'tif'].includes(fileInfo.fileType)" alt=''
				/>
				<img
					src="@comm/images/document-conversion/zxyl/ppt_icon.png"
					v-else-if="['ppt', 'pptx'].includes(fileInfo.fileType)" alt=''
				/>
				<img
					src="@comm/images/document-conversion/zxyl/wps_icon.png"
					v-else-if="['wps'].includes(fileInfo.fileType)" alt=''
				/>
				<img
					src="@comm/images/document-conversion/zxyl/txt1_icon.png"
					v-else-if="fileInfo.fileType == 'txt'" alt=''
				/>
				<img
					src="@comm/images/document-conversion/zxyl/img_icon.png"
					v-else-if="['jpg', 'png', 'bmp'].includes(fileInfo.fileType)" alt=''
				/>
				<img src="@comm/images/document-conversion/zxyl/error_img.png" v-else alt=''/>
				<a v-if="fileInfo" :title="fileInfo.sName">{{ fileInfo.sName | limitFileName(20, true) }}</a>
			</div>
			<div class="right" v-if="isPhone === 'true'" @click.stop="showBottomBox = !showBottomBox">
				<span class="mobile_home"></span>
			</div>
			<div class="right" v-else>
				<div class="item" @click="printBth">
					<span class="dy_icon"></span>
					打印
				</div>
				<div class="item" @click="handleCheck">
					<span class="phone_icon"></span>
					手机查看
				</div>
				<div class="item" @click="moreBtn">
					<span class="more_icon"></span>
					更多
				</div>
			</div>
		</div>
		<div class="reader">
			<!-- 轻阅读 -->
			<iframe v-if="!isShowExample" id="web-reader" ref="iframe" :src="readerUrl" frameborder="0" allowfullscreen="true"></iframe>
            <img v-else src="@comm/images/document-conversion/electronicDocuments/electronic.png" alt="">
		</div>
		<div class="qrcode_box" v-if="showPhone">
			<div class="qrcode_body">
				<p class="name">手机扫描二维码预览文件</p>
				<div class="qrcode_main">
					<div id="qrcode" class="qrcode" ref="qrcode"></div>
					<div class="qrcode_cover"></div>
				</div>
				<a class="sname" :title="fileInfo.fileName">{{ fileInfo.fileName | limitFileName(10) }}</a>
				<p class="size">文档大小：{{ fileInfo.fileSize }}</p>
				<div class="closed_btn" @click="showPhone = false"></div>
			</div>
		</div>
		<div class="qrcode_box more_box" v-if="showMore">
			<div class="qrcode_body">
				<div class="list" @click="helpBtn">帮助</div>
				<div class="list" @click="feedBtn">意见反馈</div>
				<div class="list" @click="aboutBtn">关于</div>
			</div>
		</div>
		<feed-back :showFeedDialog="showFeedDialog" @closed="closedFeedDialog"></feed-back>
		<about-read :showReadDialog="showReadDialog" @closed="closedReadDialog"></about-read>
		<div class="bottom_box" v-if="showBottomBox">
			<ul>
				<li @click.stop="downBtn" v-if="isDownBtn&&fileInfo.fileType != 'ofd'">
					<span class="xz"></span>下载
				</li>
				<li @click.stop="helpBtn">
					<span class="bz"></span>帮助
				</li>
				<li @click.stop="feedBtn">
					<span class="yjfk"></span>意见反馈
				</li>
				<li @click.stop="aboutBtn">
					<span class="gy"></span>关于
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { saveAs } from "file-saver";
import { downloadUploadFile, transferFileInfo, invoiceInfoFileInfo } from "@comm/api/document-conversion";
import feedBack from "@comm/components/document-conversion/feedback";
import aboutRead from "@comm/components/document-conversion/aboutRead";
import common from "@comm/utils/common";
import QRCode from "qrcodejs2";
import { Base64 } from "js-base64";
import { getfilesize } from "@comm/utils/tools";
import { getWpsUserInfo } from "@comm/api/public-user/user";
import { getUserInfo, setToken, setUserInfo } from "@comm/utils/auth";
export default {
	components: { feedBack, aboutRead },
	name: "readPage",
    props: {
        isShowExample: {
            type: Boolean,
            default: false
        }
    },
	data() {
		return {
			isPhone: false,
			showPhone: false,
			dialogShare: false,
			readerUrl: "",
			interval: null,
			fileInfo: null,
			shareUrl: "",
			showMore: false,
			showFeedDialog: false,
			showReadDialog: false,
			isDownBtn: true,
			page: "",
			fileId: "",
			code: null,
			userInfo: null,
			path: '',
			showBottomBox: false
		};
	},

	beforeCreate() {
		this.isPhone = localStorage.getItem("isPhone");
		if (this.isPhone === 'true') {
			document.querySelector('body').setAttribute('style', 'min-width:auto;overflow: hidden;')
		}

	},
	beforeDestroy() {
		if (this.isPhone === 'true') {
			document.body.removeAttribute('style')
		}
	},
	created() {
		this.isPhone = localStorage.getItem("isPhone");
		this.page = this.$route.path;
		this.userInfo = getUserInfo() ? JSON.parse(getUserInfo()) : null;
		this.path = this.$route.path;
		this.code = this.$route.query.code ? this.$route.query.code : null;
		if (this.code && !this.userInfo) {
			this.getUserInfoWps();
		}
		let that = this
		let path = this.$route.params.id;
		if (path) {
			var index = path.lastIndexOf(":");
			this.fileId = path.substring(index + 1, path.length);
			setTimeout(function () {
				that.getInfo();
			}, 1000);
			
		}

	},
	mounted() { },
	beforeDestroy() { },
	watch: {

	},
	methods: {
		getUserInfoWps() {
			getWpsUserInfo({
				code: this.code
			}).then((res) => {
				if (res.code === 100016) {
					this.$router.push({
						path: this.$route.path
					});
				} else {
					if (!this.userInfo) {
						let path = this.$route.params.url;
						if (path) {
							var index = path.lastIndexOf(":");
							this.fileId = path.substring(index + 1, path.length);
							this.getInfo();
						}
					}
					this.userInfo = res.data;
					setToken(this.userInfo.token);
					setUserInfo(JSON.stringify(this.userInfo));
				}
			});
		},
		getInfo() {
			invoiceInfoFileInfo(this.fileId).then((res) => {
				this.fileInfo = res.data;
				document.title = this.fileInfo.fileName;
				let fileUrl = Base64.encode(this.fileInfo.fileName + "|" + this.fileInfo.fileUrl);
				fileUrl = encodeURIComponent(fileUrl);
				let webUrl = localStorage.getItem("webUrl") ? localStorage.getItem("webUrl") : common.baseurl;
				// this.readerUrl = `${webUrl}?file=${fileUrl}&type=onlinePreview`;
				const concatURL = encodeURIComponent(`${common.apiUrl}/pubservice/file/info?ticket=${this.fileId}`);
				this.readerUrl = `${webUrl}?file=${concatURL}&type=onlinePreview`;
				var index = this.fileInfo.fileName.lastIndexOf(".");
				this.fileInfo.sName = this.fileInfo.fileName.substring(0, index);
				this.fileInfo.fileSize = this.fileInfo.fileSize ? getfilesize(this.fileInfo.fileSize) : "0M";
			});
		},
		downBtn() {
			this.showPhone = false;
			this.showMore = false;
			this.showBottomBox=false
			downloadUploadFile({
				fileId: this.fileId,
				fileName: encodeURIComponent(this.fileInfo.fileName)
			}).then((res) => {
				if (!res) {
					Message.error("下载文件失败");
					return false;
				}
				let filename = this.fileInfo.fileName;
				const blob = new Blob([res.data]);
				if (sessionStorage.getItem("browserType") == "IE") {
					saveAs(blob, filename);
				} else {
					const downloadElement = document.createElement("a");
					const href = window.URL.createObjectURL(blob); // 创建下载的链接
					downloadElement.href = href;
					downloadElement.download = decodeURIComponent(filename);
					// downloadElement.download = file.file.filename
					document.body.appendChild(downloadElement);
					downloadElement.click(); // 点击下载
					document.body.removeChild(downloadElement); // 下载完成移除元素
					window.URL.revokeObjectURL(href); // 释放blob对象
				}
			})
				.catch((err) => {
					if (err.code == "ECONNABORTED" && err.message.indexOf("timeout") != -1) {
						this.$alert("网络不佳或内容过大", "提示", {
							confirmButtonText: "确定"
						});
					}
				});
		},
		printBth() {
			this.showPhone = false;
			this.showMore = false;
			this.$refs.iframe.contentWindow.postMessage(["click", "print"], "*");
		},
		handleCheck(val) {
			this.showMore = false;
			this.showPhone = !this.showPhone;
			let url = "";
			url = `${common.readCodeUrl}/readering:${this.fileId}`;
			if (this.showPhone) {
				this.$nextTick(() => {
					this.makeQrcode(url);
				});
			}
		},
		closedFeedDialog(data) {
			this.showFeedDialog = data;
		},
		closedReadDialog(data) {
			this.showReadDialog = data;
		},
		feedBtn() {
			if (this.isPhone !== 'true') {
				this.showMore = !this.showMore;
			}
			this.showBottomBox=false
			this.showFeedDialog = true;
		},
		helpBtn() {
			if (this.isPhone !== 'true') {
				this.showMore = !this.showMore;
			}
			this.showBottomBox=false
			window.open("http://suwell.cn/", "_blank");
		},
		aboutBtn() {
			if (this.isPhone !== 'true') {
				this.showMore = !this.showMore;
			}
			this.showBottomBox=false

			this.showReadDialog = true;
		},
		moreBtn() {
			this.showPhone = false;
			if (this.isPhone !== 'true') {
				this.showMore = !this.showMore;
			}
		},
		makeQrcode(text) {
			new QRCode("qrcode", {
				width: 142, // 设置宽度，单位像素
				height: 142, // 设置高度，单位像素
				correctLevel: 3,
				text // 设置二维码内容或跳转地址
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.bottom_box {
	width: 100%;
	height: 100%;
	border-radius: 10px 10px 0 0;
	background-color: rgba(0,0,0,.6);
	position: fixed;
	bottom: 0;
	left: 0;
	z-index: 999;
	ul{
		background-color: #fff;
		position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	}li {
		padding: 20px 20px 10px 30px;
		line-height: 18px;
		font-size: 14px;
		background-color: #fff;
		span {
			display: inline-block;
			width: 20px;
			height: 20px;
			margin-right: 20px;
			vertical-align: middle;
			&.xz {
			background: url("../../comm/images/document-conversion/down_icon.svg")
				0 0 no-repeat;
			background-size: 100%;
		}
		&.bz {
			background: url("../../comm/images/document-conversion/mobileIcon/icon_03.svg")
				0 0 no-repeat;
			background-size: 100%;
		}
		&.yjfk {
			background: url("../../comm/images/document-conversion/mobileIcon/icon_04.svg")
				0 0 no-repeat;
			background-size: 100%;
		}
		&.gy {
				background: url("../../comm/images/document-conversion/mobileIcon/icon_05.svg")
					0 0 no-repeat;
				background-size: 100%;
			}
		}

		&:nth-child(4) {
			padding-bottom: 20px;
		}
	}
}
.readpage_body {
    position: relative;
	background: #ffffff;
	height: 100%;
	overflow-y: hidden;
	display: flex;
	flex-direction: column;
	.readpage_top {
        position: relative;
		height: 44px;
		background: #f5f5f5;
		padding: 0 15px 0 10px;
		border-bottom: 1px solid #eaeaea;
		// display: flex;
		// align-items: center;
		// justify-content: space-between;
		.left {
			height: 44px;
			font-size: 14px;
			color: #000000;
			float: left;
			display: flex;
			align-items: center;
			img {
				display: inline-block;
				width: 32px;
				height: 32px;
				margin-right: 6px;
				vertical-align: middle;
			}
		}
		.right {
			height: 44px;
			float: right;
			font-size: 12px;
			color: #333333;
			display: flex;
			align-items: center;
			position: relative;
			.mobile_home {
				width: 20px;
				height: 20px;
				background: url("../../comm/images/document-conversion/mobileIcon/home.svg")
					0 0 no-repeat;
				background-size: 100%;
				display: block;
			}
			.item {
				margin-left: 15px;
				width: auto;
				padding: 5px 0;
				&:hover {
					cursor: pointer;
					background: #e4e4e4;
					border-radius: 2px;
				}
			}
			span {
				display: inline-block;
				width: 24px;
				height: 24px;
				margin-right: 5px;
				vertical-align: middle;
				&.down_icon {
					background: url("../../comm/images/document-conversion/zxyl/down_btn.png")
						0 0 no-repeat;
					background-size: 100%;
				}
				&.dy_icon {
					background: url("../../comm/images/document-conversion/zxyl/dy_icon.png")
						0 0 no-repeat;
					background-size: 100%;
				}
				&.share_icon {
					background: url("../../comm/images/document-conversion/zxyl/share_icon.png")
						0 0 no-repeat;
					background-size: 100%;
				}
				&.phone_icon {
					background: url("../../comm/images/document-conversion/zxyl/phone_icon.png")
						0 0 no-repeat;
					background-size: 100%;
				}
				&.more_icon {
					background: url("../../comm/images/document-conversion/zxyl/more_icon.png")
						0 0 no-repeat;
					background-size: 100%;
				}
			}
		}
	}
	.reader {
		flex: 1;
		height: auto;
	}
	.qrcode_box {
		width: 198px;
		height: 246px;
		background: #ffffff;
		box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
		position: absolute;
		top: 44px;
		right: 32px;
		z-index: 999;
		&.more_box {
            position: absolute;
			width: 139px;
			height: 82px;
			border-radius: 2px;
			border: 1px solid #cccccc;
			right: 15px;
			.qrcode_body {
				padding: 5px 0;
				align-items: flex-start;
				.list {
					height: 24px;
					padding: 0 23px;
					line-height: 24px;
					font-size: 12px;
					color: #333333;
					width: 100%;
					cursor: pointer;
					&:hover {
						background: #f5f5f5;
					}
				}
			}
		}
		.qrcode_body {
			position: relative;
			display: flex;
			flex-direction: column;
			align-items: center;
			.qrcode_main {
				width: 150px;
				height: 150px;
				border: 1px solid #e7e7e7;
				margin: 4px 0;
				position: relative;
				.qrcode {
					margin: 4px auto;
					width: 142px;
					height: 142px;
				}
				.qrcode_cover {
					width: 142px;
					height: 142px;
					position: absolute;
					top: 4px;
					left: 4px;
					background: transparent;
				}
			}
			.closed_btn {
				position: absolute;
				top: 15px;
				right: 15px;
				width: 17px;
				height: 16px;
				background: url("../../comm/images/document-conversion/zxyl/close_btn.png")
					0 0 no-repeat;
				background-size: 100%;
			}
			.name {
				font-size: 12px;
				color: #333333;
				line-height: 16px;
				margin-top: 28px;
			}
			.sname {
				font-size: 12px;
				color: #008ad9;
				line-height: 18px;
				text-decoration: none;
			}
			.size {
				font-size: 12px;
				color: #b1b1b1;
				line-height: 18px;
			}
		}
	}
}
</style>




// WEBPACK FOOTER //
// src/supubwps-document-conversion/pages/reading.vue